import { useCallback } from "react";
import { SlidersHorizontal } from "lucide-react";

import ACL_RELATIONSHIPS from "acl-relationships";
import { getNextQueryParams } from "components/helpers";
import BaseTableV3 from "components/BaseTableV3/BaseTableV3";
import { TableCreateButton } from "components/BaseTableV3/TableCreateButton";
import CustomFieldService from "services/CustomField";
import {
  invalidateCustomFieldConfigsQuery,
  useCustomFieldConfigTable,
} from "hooks/useCustomFieldConfigTable";

export const CUSTOM_FIELD_CONFIG_TABLE_CONSTANTS = {
  tableName: "custom_field_configs",
  queryKey: "custom-field-configs",
  exportTableName: "CustomFieldConfigTable",
  className: "CustomFieldConfig",
  header: "Custom Field Configs",
  headerIcon: SlidersHorizontal,
};

const CREATE_ACLS = [ACL_RELATIONSHIPS.customFieldConfig.create];

const CustomFieldConfigTableV3 = () => {
  const { columns, filters } = useCustomFieldConfigTable();

  const fetchCustomFieldConfigs = useCallback(
    async queryParams => {
      try {
        const nextQueryParams = getNextQueryParams(queryParams, columns);

        const response =
          await CustomFieldService.getCustomFieldConfigsTable(nextQueryParams);

        return response;
      } catch (error) {
        console.error("Error fetching custom field configs:", error);
        throw error;
      }
    },
    [columns]
  );

  return (
    <BaseTableV3
      columns={columns}
      filters={filters}
      className={CUSTOM_FIELD_CONFIG_TABLE_CONSTANTS.className}
      headerIcon={CUSTOM_FIELD_CONFIG_TABLE_CONSTANTS.headerIcon}
      header={CUSTOM_FIELD_CONFIG_TABLE_CONSTANTS.header}
      queryKey={CUSTOM_FIELD_CONFIG_TABLE_CONSTANTS.queryKey}
      exportTableName={CUSTOM_FIELD_CONFIG_TABLE_CONSTANTS.exportTableName}
      tableName={CUSTOM_FIELD_CONFIG_TABLE_CONSTANTS.tableName}
      createButton={
        <TableCreateButton
          permissions={CREATE_ACLS}
          to="/settings/custom_field_configs/new"
        >
          New Custom Field
        </TableCreateButton>
      }
      fetchData={fetchCustomFieldConfigs}
      invalidateData={invalidateCustomFieldConfigsQuery}
      enableSettings
      enableSearch
    />
  );
};

export default CustomFieldConfigTableV3;
